(function( $, window, document, undefined ) {
    /**
     * Migrate class.
     *
     * @param {int} total_records
     * @constructor
     */
    function Migrate(total_records) {
        "use strict";

        // Initialise the progress bar.
        var instance = this,
            timer = new easytimer.Timer(),
            $textarea = $('textarea'),
            progressbar = $("#progressbar"),
            progressLabel = $(".progress-label"),
            totalRequests = 0;

        // Initialise the timer.
        timer.addEventListener('secondTenthsUpdated', function (e) {
            $('#runningTime').html(timer.getTimeValues().toString(['days', 'hours', 'minutes', 'seconds', 'secondTenths']));
        });

        /**
         * Determine if a string is valid JSON.
         *
         * @param str
         * @return boolean
         */
        var isValidJson = function (str) {
            try {
                JSON.parse(str);

                return true;
            } catch (e) {
                return false;
            }
        }

        /**
         * Update the textarea log.
         *
         * @param json
         */
        var updateLog = function (json)
        {
            var text = [];

            if (typeof json.verbose !== 'undefined' && json.verbose.length > 0) {
                text.push(json.verbose.join('\n'));
            }

            if (typeof json.errors !== 'undefined' && json.errors.length > 0) {
                text.push('Error log: \n\t' + json.errors.join('\n\t'));
            }

            $textarea.text(text.length ? text.join('\n') : json).scrollTop($textarea[0].scrollHeight);
        }

        /**
         * Fatal error handler.
         *
         * @param string
         */
        var fatalHandler = function (string)
        {
            $textarea.text("Fatal error - see logs for more information!\n" + $(string).text())
                .scrollTop($textarea[0].scrollHeight);

            timer.stop();

            alert("Something went wrong.");
        }

        /**
         * AJAX error handler.
         *
         * @param string
         * @return void
         */
        var retryHandler = function (string)
        {
            $textarea.text(
                "Something went wrong while contacting the server!\n"
                + $(string).text()
                + "\n\nWaiting 5 seconds before retrying..."
            ).scrollTop($textarea[0].scrollHeight);

            window.setTimeout(function () {
                instance.makeRequest();
            }, 5000);
        }

        /**
         * Convert milliseconds to a human readable string.
         *
         * @param duration
         * @returns {string}
         */
        var msToTime = function (duration)
        {
            var milliseconds = parseInt((duration % 1000) / 100),
                seconds = parseInt((duration / 1000) % 60),
                minutes = parseInt((duration / (1000 * 60)) % 60),
                hours = parseInt((duration / (1000 * 60 * 60)) % 24);

            hours = (hours < 10) ? "0" + hours : hours;
            minutes = (minutes < 10) ? "0" + minutes : minutes;
            seconds = (seconds < 10) ? "0" + seconds : seconds;

            return hours + ":" + minutes + ":" + seconds + "." + milliseconds;
        }

        /**
         * Make new AJAX request. This will continuously process all migrations until complete.
         *
         * @internal
         */
        this.makeRequest = function ()
        {
            $('#totalRequests').text(totalRequests++);
            var start_time = new Date();

            $.post('index.php?step=5', { 'ajax': true }, null, 'json')
                .done(function (json, textStatus, jqXHR) {
                    // Make sure we have valid json
                    if (! isValidJson(jqXHR.responseText) || typeof json.data === 'undefined') {
                        return retryHandler('<span>'+jqXHR.responseText+'</span>');
                    }

                    // Catchable fatal error.
                    if (typeof json.status === 'undefined' || json.status !== 'success') {
                        return fatalHandler(json.message);
                    }

                    // Update the log.
                    json = json.data;
                    updateLog(json);

                    // Update progress bar
                    progressbar.progressbar('value', (progressbar.progressbar("value") || 0) + (json.current || 0));

                    // Non retryable error so exit now.
                    if (typeof json.errors !== 'undefined' && json.errors.length > 0
                        && typeof json.retry_after !== 'undefined' && json.retry_after === null
                    ) {
                        return fatalHandler('');
                    }

                    // Fire the next request.
                    if (typeof json.complete !== 'undefined' && json.complete === false) {
                        // Use retry_after if specified, otherwise run immediately.
                        var timeout = typeof json.retry_after !== 'undefined' && json.retry_after !== null ? json.retry_after : 0;
                        window.setTimeout(function () {
                            instance.makeRequest();
                        }, timeout);
                    }

                    // Manually mark as complete, some migrations such as freshdesk have to disable the progressbar
                    // but we still want to show when the migration finished.
                    if (typeof json.complete !== 'undefined' && json.complete === true) {
                        progressbar.progressbar("option", "max", 100);
                        progressbar.progressbar('value', 100);
                        progressbar.show();
                    }
                })
                .fail(function (jqXHR, textStatus, errorThrown) {
                    if (isValidJson(jqXHR.responseText)) {
                        // Catchable fatal error.
                        fatalHandler(JSON.parse(jqXHR.responseText).message);
                    } else {
                        retryHandler(jqXHR.responseText);
                    }
                })
                .always(function () {
                    var end_time = new Date(),
                        duration = end_time.getTime() - start_time.getTime();

                    $('#startTime').text(start_time.toTimeString());
                    $('#endTime').text(end_time.toTimeString());
                    $('#duration').text(msToTime(duration));
                });
        };

        /*
         * Construct / initialise.
         */

        // Prevent closing of the browser window.
        window.onbeforeunload = function (e) {
            return "Are you sure you want to close the browser window?";
        };

        // In order for onbeforeunload to work, user interaction is required on the page.
        $('#beginMigration').on('click', function (e) {
            e.preventDefault();

            Swal.fire({
                title: 'Database Backup',
                html: '<div>'
                    + '<div class="sp-alert sp-alert-warning sp-uppercase">'
                    + '<i class="fa fa-exclamation-triangle" aria-hidden="true"></i> &nbsp;'
                    + 'This action cannot be undone!'
                    + '</div>'
                    + 'The migration may make irreversible changes to your <strong>SupportPal</strong> database. Please ensure you have a valid backup of your database before proceeding.'
                    + '</div>',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Continue',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Go back',
            }).then(function (result) {
                if (result.value) {
                    // Initialise statistics.
                    $('#totalRequests').text(totalRequests);
                    timer.start();

                    // Show migration log and progress bar.
                    $('#pre-migration, #migration').toggleClass('sp-hidden');

                    // Start migration AJAX requests.
                    instance.makeRequest();
                }
            });
        });

        progressbar.progressbar({
            max: total_records,
            value: false,
            change: function () {
                var width = $('.ui-progressbar-value')[0].style.width;

                progressLabel.text(parseInt(width.replace('%', '')) >= 100 ? 'Complete!' : width);
            },
            complete: function () {
                progressLabel.text("Complete!");
                timer.stop();
            }
        });
    }

    App.extend('Migrate', Migrate);
})($, window, document);
